import { createStateHook } from '@atlassian/react-sweet-state';
import { Store } from './index.tsx';

export const useSearchKey = createStateHook(Store, { selector: (state) => state.searchKey });
